import { ChangeDetectionStrategy, Component } from "@angular/core";
import { BulkUploadLayoutComponent } from "@m19-board/bulk-upload/bulk-upload-layout/bulk-upload-layout.component";
import { provideBulkUpload } from "@m19-board/services/bulk-upload/bulk-upload.tokens";
import { TacosBulkUploadHandler } from "@m19-board/services/bulk-upload/tacos/tacos-bulk-upload-handler.service";

@Component({
  selector: "app-tacos-bulk-upload-page",
  imports: [BulkUploadLayoutComponent],
  providers: [provideBulkUpload(TacosBulkUploadHandler)],
  template: `<app-bulk-upload-layout />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TacosBulkUploadPageComponent {}
